import { StaffPositionEnum } from '../../../../lib/types/enums/staff/staff-position.enum'
import {
  isStaffEnglish,
  StaffQualificationEnum
} from '../../../../lib/types/enums/staff/staff-qualifications.enum'
import { DiplomaEnum } from '../../../../lib/types/enums/staff-application/diploma.enum'
import { NationalEducationStatusEnum } from '../../../../lib/types/enums/staff-application/national-education-status.enum'

export const diplomasWithPaySlip = [DiplomaEnum.CAPES, DiplomaEnum.PLP2, DiplomaEnum.AGREGATION]

export const diplomasThatRequireFiles: DiplomaEnum[] = [
  DiplomaEnum.BAFA,
  DiplomaEnum.BAFD,
  DiplomaEnum.PSC1_AFPS,
  DiplomaEnum.SB,
  DiplomaEnum.TEFL_CELTA,
  DiplomaEnum.OTHER
]

// The pay slip is asked to every teacher whatever their diplomas, to an AAT only with a CAPES, PLP2
// or Agrégation or when they are (or were) in the national education, never to an animator nor to
// English staff. The backend rule (staff missing documents) does not know the national education
// condition for an AAT: such an AAT sees the slot but is not reminded of a missing pay slip
export const isStaffPaySlipRequired = ({
  position,
  qualifications,
  diplomas,
  memberOfNationalEducationStatus
}: {
  position?: StaffPositionEnum
  qualifications?: StaffQualificationEnum[]
  diplomas?: { type: DiplomaEnum }[]
  memberOfNationalEducationStatus?: NationalEducationStatusEnum | null
}): boolean => {
  if (isStaffEnglish({ qualifications })) return false
  if (position === StaffPositionEnum.TEACHER) return true
  if (position === StaffPositionEnum.ANIMATOR) return false

  return (
    !!diplomas?.some((diploma) => diplomasWithPaySlip.includes(diploma.type)) ||
    memberOfNationalEducationStatus === NationalEducationStatusEnum.MEMBER ||
    memberOfNationalEducationStatus === NationalEducationStatusEnum.RETIRED
  )
}
